<div class="header">
    <div class="header-left">
        <a class="back" routerLink=".." data-test="dialog-create-module-back">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ 'courses.modules.dialog.create.title' | translate }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-create-module-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'modules.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'modules.form.name' | translate"
            [placeholder]="'modules.form.name.placeholder' | translate"
            inputId="name"
            testId="dialog-create-module-name"
        />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'modules.form.description' | translate"
            [placeholder]="'modules.form.description.placeholder' | translate"
            inputId="description"
            testId="dialog-create-module-description"
        />
    </div>
</form>

<div class="footer">
    <a pButton [outlined]="true" severity="secondary" data-test="dialog-create-module-cancel" routerLink="..">
        <span pButtonLabel>{{ 'modules.form.cancel' | translate }}</span>
    </a>
    <p-button
        type="submit"
        [label]="'courses.modules.dialog.create.submit' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="dialog-create-module-submit"
        (onClick)="onSubmit()"
    />
</div>
